<template>
  <div class="print-box tem p-1">
    <table class="prtable prtable-center prtable-bordered">
      <tr>
        <td>Tên hàng</td>
        <td colspan="4" style="font-size: 13px;">
          <b v-if="manufacture.product">{{ manufacture.product.name }} </b>
          <!-- <span v-if="manufacture.productCustom != ''"><br>{{ manufacture.productCustom }}</span> -->
          <b v-if="manufacture.reason"><br />{{ manufacture.reason.name }}</b>
        </td>
      </tr>
      <tr>
        <td>Mã SP</td>
        <td colspan="4" style="font-size: 15px;">
          <b v-if="manufacture.product">{{ manufacture.product.code }}</b>
        </td>
      </tr>
      <tr>
        <td>Quy cách</td>
        <td colspan="2" style="font-size: 15px;">
          <b v-if="manufacture.productSpecify">{{ manufacture.productSpecify.name }}</b>
        </td>
        <td colspan="2" style="font-size: 15px;">mm</td>
        <!-- <td>{{ manufacture.length }} cm</td> -->
      </tr>
      <tr>
        <td>Chiều dài</td>
        <td colspan="2" style="font-size: 15px;">
          {{ manufacture.length }}
        </td>
        <td colspan="2" style="font-size: 15px;">cm</td>
      </tr>
      <tr>
        <td>Màu sắc</td>
        <td colspan="2" style="font-size: 15px;">
          <b>{{ manufacture.colorText }}</b>
        </td>
        <td colspan="2" style="font-size: 15px;">{{ manufacture.colorCode1 }}</td>
      </tr>
      <tr>
        <td>Số lượng</td>
        <td style="font-size: 15px;">
          <b>{{ Tem.slbichOdd }}</b>
        </td>
        <td style="font-size: 15px;">{{ manufacture.unit }}</td>
        <td colspan="2" style="font-size: 15px;">
          <span style="display: flex;align-items:center" title="5:">
            <base-input style="min-width:60px" v-model="Tem.slcbichOdd" :mask="'number'"></base-input>
            <div style="width:50px">
              <span style="display:block; border-bottom:1px solid #000">C</span>
              <span>B</span>
            </div>
          </span>
        </td>
      </tr>
      <tr>
        <td>Số Lot</td>
        <td colspan="2" style="font-size: 15px; min-width: 150px;">
          <b>{{ manufacture.code }}</b>
        </td>
        <td colspan="2" style="font-size: 15px;">
          <span title="6: Trọng lượng gộp">
            {{
              $formatNumberFixed(
                Number(this.Tem.hesobichOdd) * Number(this.Tem.slcbichOdd) + Number(this.Tem.tlbichOdd)
              )
            }}
            <!-- <base-input
              placeholder="TL / cuộn"
              v-model="Tem.tlcOdd"
              :mask="'number'"
            ></base-input> -->
          </span>
        </td>
      </tr>
      <tr>
        <td>QC</td>
        <td colspan="2" style="width:100px; font-size: 15px;">
          <span title="8: Trọng lượng">
            <base-input v-model="Tem.hesobichOdd" placeholder="Hệ số" :mask="'number'"></base-input>
          </span>
        </td>
        <td colspan="2" style="font-size: 15px;">
          <span title="7 : Trọng lượng tịnh">
            <base-input v-model="Tem.tlbichOdd" :mask="'number'"></base-input>
          </span>
        </td>
      </tr>
      <tr>
        <td>Note</td>
        <td colspan="4" style="width:100px; font-size: 15px;">
          <textarea v-model="Tem.noteOdd" placeholder="Ghi chú" class="form-control"></textarea>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
import VueBarcode from 'vue-barcode';
export default {
  name: 'tem-bich-odd',
  components: {
    barcode: VueBarcode
  },
  props: {
    manufacture: {},
    code: {},
    Tem: {},
    quantityOdd: {}
  }
};
</script>
